export default () => {
  let exp = 'sitename';
  if (typeof window !== 'undefined') {
    exp = window.location.hostname;
  }
  // return 'staginga.noustalk.com';
  return exp;
  // return 'staging.noustalk.com'; // this is the staging server at https://staging.noustalk.com/
};
